import React, { Component } from 'react';
// eslint-disable-next-line react/prefer-stateless-function
export default class Quotes extends Component {
  render() {
    return (
      <div className="quote-container">
        <h1 className="quote">
          Mathematics is not about numbers, equations, computations, or
          algorithms: it is about understanding - williams Paul Thurston
        </h1>
        <hr />
      </div>
    );
  }
}
